import { a as __rest } from '../../_tslib.esm.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { forwardRef, useId } from 'react';
import styles from './IconButton.styles.esm.js';
import { simulateButtonKeyboardBehavior } from '../../testUtils/buttonKeyboardBehavior.esm.js';
import { cn } from '../../utils/cn.esm.js';

const IconButton = forwardRef((props, ref) => {
  const generatedId = useId();
  const {
      id = generatedId,
      orientation = "vertical",
      size = "sm",
      showLabel = true,
      className = "",
      label,
      onClick,
      icon: Icon,
      href,
      inverse = false
    } = props,
    otherProps = __rest(props, ["id", "orientation", "size", "showLabel", "className", "label", "onClick", "icon", "href", "inverse"]);
  const classes = styles({
    orientation,
    size,
    inverse
  });
  const Tag = React__default.useMemo(() => href ? "a" : "button", [href]);
  // Get classname from the icon if it's a valid React element
  const parentIconClassName = React__default.useMemo(() => {
    var _a;
    return React__default.isValidElement(Icon) ? ((_a = Icon === null || Icon === void 0 ? void 0 : Icon.props) === null || _a === void 0 ? void 0 : _a.className) || "" : "";
  }, [Icon]);
  return jsxs(Tag, Object.assign({
    id: id,
    ref: ref,
    className: classes.root({
      class: className
    }),
    type: "button",
    onClick: onClick,
    "aria-label": otherProps["aria-label"],
    // Just pass when href exists
    href: href ? href : undefined,
    onKeyDown: href ? simulateButtonKeyboardBehavior : undefined
  }, otherProps, {
    children: [jsx("span", {
      className: cn(classes.icon(), parentIconClassName),
      "aria-hidden": showLabel,
      children: Icon
    }), showLabel && label ?
    // just showing when have label and show label is true
    jsx("span", {
      className: classes.label(),
      children: label
    }) : null]
  }));
});

export { IconButton };
